// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__S0Mp-","header":"PatientBlock_header__WB6Z8","label":"PatientBlock_label__1m2Zo","option":"PatientBlock_option__3KDQr"};